
import * as handlebars_family from "../handlebars_family.js";
import "../list/task_quickadd.mustache";
import "../list/task-container-content.mustache";
import "../widget/action-menu.js";
const TPL = handlebars_family.addTemplate("mealplanner/tasklist",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexcol data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" style=\"--list-color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\"><div style=\"margin:8px 0 16px 0\"><flexrow data-widget=\"widget/action-menu\" data-key=\"mealplannerlist\" style=\"gap:var(--space-s)\"><icon>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"iconsimple") : depth0), depth0)) != null ? stack1 : "")
    + "</icon><flexauto style=\"font-weight:500\"> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + " <icon class=\"rotateable\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_chevron_down",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":314},"end":{"line":1,"column":343}}}))
    + "</icon></flexauto></flexrow> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"list/task_quickadd"),depth0,{"name":"list/task_quickadd","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </div><flexauto id=\"task-container\"> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"list/task-container-content"),depth0,{"name":"list/task-container-content","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </flexauto></flexcol> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  stack1 = ((helper = (helper = lookupProperty(helpers,"list") || (depth0 != null ? lookupProperty(depth0,"list") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"list","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":497}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"list")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { return stack1; }
  else { return ''; }
},"usePartial":true,"useData":true});
export default TPL;